<template>
  <header fluid class="hm-header position">
    <div class="container">
      <nav class="navbar navbar-dark navbar-light navbar-expand-md">
        <ul class="navbar-nav">
          <div class="navbar-brand">
            <router-link to="/" class="router-link-exact-active">
              <img src="../assets/images/tablog.png" alt="禾苗(武汉)信息技术有限公司" class="logo">
            </router-link>
          </div>
        </ul>
        <button 
          type="button" 
          aria-label="Toggle navigation" 
          class="navbar-toggler collapsed" 
          aria-expanded="false" 
          aria-controls="nav_collapse"
          @click="toggleNav"
        >
          <img src="../assets/images/phone.png" alt="电话图标" style="height: 24px; width: auto;">
        </button>
        <div 
          id="nav_collapse" 
          class="navbar-collapse collapse" 
          :style="{ display: isNavOpen ? 'block' : 'none' }"
        >
          <ul class="navbar-nav flex-between hm-link">
            <li class="nav-item">
              <router-link to="/" class="nav-link">首页</router-link>
            </li>
            <!-- <li class="nav-item b-nav-dropdown dropdown" id="__BVID__13">
              <a 
                role="button" 
                aria-haspopup="true" 
                aria-expanded="false" 
                href="#" 
                target="_self" 
                class="nav-link dropdown-toggle"
                @click="toggleDropdown"
              >
                <span>产品介绍</span>
              </a>
              <ul 
                tabindex="-1" 
                class="dropdown-menu dropdown-menu-right"
                :style="{ display: isDropdownOpen ? 'block' : 'none' }"
              >
                <router-link to="/hexiao" class="dropdown-item">禾销-导购激励平台</router-link>
                <router-link to="/hemiao" class="dropdown-item">禾心零售-新零售小程序</router-link>
              </ul>
            </li>
            <li class="nav-item">
              <router-link to="/cooperation" class="nav-link">合作案例</router-link>
            </li> -->
            <li class="nav-item">
              <router-link to="/about/hxnews" class="nav-link">新闻中心</router-link>
            </li>
          </ul>
          <ul class="navbar-nav">
            <li class="nav-item phone flex-1">
              <a href="tel:15392850129" target="_self" class="nav-link">
                联系我们：153 9285 0129
              </a>
            </li>
          </ul>
        </div>
      </nav>
    </div>
  </header>
</template>

<script>
export default {
  name: 'Header',
  data() {
    return {
      isNavOpen: false,
      isDropdownOpen: false
    }
  },
  methods: {
    toggleNav() {
      this.isNavOpen = !this.isNavOpen
      // 如果打开导航栏，关闭下拉菜单
      if (this.isNavOpen) {
        this.isDropdownOpen = false
      }
    },
    toggleDropdown() {
      this.isDropdownOpen = !this.isDropdownOpen
    }
  },
  mounted() {
    // 监听点击外部事件，关闭下拉菜单
    document.addEventListener('click', (e) => {
      const dropdown = this.$el.querySelector('.dropdown')
      if (dropdown && !dropdown.contains(e.target)) {
        this.isDropdownOpen = false
      }
    })
  }
}
</script>

<style scoped>
.hm-header {
  background-color: rgba(0, 0, 0, 0.3); /* 类似banner文字区域的半透明效果 */
  backdrop-filter: blur(5px); /* 添加高斯模糊效果 */
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
}

.navbar {
  padding: 1rem 0;
}

.navbar-brand {
  margin-right: 2rem;
}

.logo {
  max-height: 40px;
}

.hm-link {
  flex: 1;
  justify-content: center;
}

.nav-item {
  margin: 0 1rem;
}

.nav-link {
  color: #fff !important;
  font-size: 16px;
  position: relative;
  padding: 0.5rem 0;
  outline: none !important;
  box-shadow: none !important;
}

.nav-link:focus {
  outline: none !important;
  box-shadow: none !important;
}

.router-link-active:focus {
  outline: none !important;
  box-shadow: none !important;
}

.nav-link:hover {
  color: #e6f0ff !important;
}

.nav-link.router-link-active {
  color: #fff !important;
  font-weight: 600;
  text-shadow: 0 0 4px rgba(255, 255, 255, 0.3);
  /* 移除下划线效果 */
}

.phone .nav-link {
  color: #fff !important;
  font-weight: 600;
  text-shadow: 0 0 4px rgba(255, 255, 255, 0.3);
}

.dropdown-menu {
  border: 0px solid #c2c5c9;
  background-color: rgba(129, 129, 129, 0.8);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
  border-radius: 4px;
  margin-top: 0.5rem;
}

.dropdown-item {
  padding: 0.75rem 1.5rem;
  transition: all 0.3s;
  color: #fff;
}

.dropdown-item:hover {
  background-color: rgba(255, 255, 255, 0.2);
  color: #fff;
}

.dropdown-item.router-link-active {
  color: #fff;
  background-color: rgba(255, 255, 255, 0.2);
  font-weight: 500;
}

@media (max-width: 767px) {
  .navbar {
    padding: 0.5rem 0;
  }
  
  .navbar-brand {
    margin-right: 0;
  }
  
  .nav-item {
    margin: 0.5rem 0;
    text-align: center;
  }
  
  .hm-link {
    flex-direction: column;
  }
  
  .dropdown-menu {
    text-align: center;
  }
}
</style>